"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _default = function _default(props) {
  var margin = props.margin,
      imageUrl = props.imageUrl,
      title = props.title,
      mobile = props.mobile,
      blobUrl = props.blobUrl;
  return /*#__PURE__*/_react["default"].createElement(Title, {
    margin: margin,
    mobile: mobile,
    className: "title"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "store-icon",
    alt: "store-icon",
    src: imageUrl
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "title-headers"
  }, mobile ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("h2", null, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "small lite"
  }, "by Raiven Marketplace")) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("h1", null, title), /*#__PURE__*/_react["default"].createElement("img", {
    alt: "qmerit-logo",
    src: blobUrl + '/procurement/branding/Powered-by-Raiven-Horizontal.svg'
  }))));
};

exports["default"] = _default;

var Title = _styledComponents["default"].div.withConfig({
  displayName: "Title",
  componentId: "bpc4z3-0"
})(["display:flex;align-items:center;flex-wrap:wrap;justify-content:center;margin:", ";.title-headers{display:flex;flex-direction:column;text-align:left;}.store-icon{height:4rem;object-fit:contain;}img{height:1rem;width:7rem;object-fit:contain;}", ""], function (_ref) {
  var margin = _ref.margin;
  return margin ? margin : 0;
}, function (_ref2) {
  var mobile = _ref2.mobile;
  return mobile && (0, _styledComponents.css)(["justify-content:flex-start;@supports (padding-top:constant(safe-area-inset-top)){--safe-area-inset-top:constant(safe-area-inset-top);margin-top:var(--safe-area-inset-top);}@supports (padding-top:env(safe-area-inset-top)){--safe-area-inset-top:env(safe-area-inset-top);margin-top:var(--safe-area-inset-top);}.light{font-size:0.75rem;}"]);
});